import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class BrokerService {

  constructor(private http: HttpClient) {
  }

  getToken(payload) {
    return this.http.post<any>(urls.BROKER_PANEL_URL + 'auth/login', payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getCancelReasons(token: any) {
    const queryParams: any = {
      isActive: true,
      limit: 9999
    }

    const params = new HttpParams({fromObject: queryParams});

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    return this.http.get<any>(urls.BROKER_PANEL_URL + 'change-reasons/picker', { params, headers })
      .pipe(
        catchError(errorHandl)
      );
  }
}
